import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { todayKey } from '@shared/utils';

/**
 * 畫面狀態。
 *
 * **這裡沒有紀錄與設定。**那些是 server state，由 TanStack Query 持有——
 * 它們的真實來源在後端，快取的新舊、重抓時機與失敗重試不是 store 該回答的問題。
 *
 * 留在這裡的只有一個純粹的 UI 狀態：使用者正在看哪一天。它不存在於後端，
 * 重新整理後回到今天是預期行為。
 */
interface DietState {
  /** 目前檢視的日期（'YYYY-MM-DD'） */
  selectedDate: string;
}

interface DietActions {
  setSelectedDate: (dateKey: string) => void;
  /** 回到初始狀態，用於登出／session 失效後。 */
  reset: () => void;
}

/**
 * 初始狀態。抽成函式而非常數：`selectedDate` 要在**呼叫當下**求值，
 * 常數會把模組載入那一刻的「今天」凍住，跨過午夜後 reset 會回到昨天。
 */
function initialState(): DietState {
  return { selectedDate: todayKey() };
}

export const useDietStore = create<DietState & DietActions>()(
  immer((set) => ({
    ...initialState(),

    setSelectedDate: (dateKey) =>
      set((state) => {
        state.selectedDate = dateKey;
      }),

    /*
     * store 存活於模組層級，不隨畫面卸載消失。session 失效時要明確清掉，否則
     * 換一個人登入後會停在前一位使用者正在看的那一天。
     */
    reset: () => set(() => initialState()),
  })),
);
